import { IconName } from '@travelata-libs/ui-kit';
import { HotelFeature } from '@/entities/hotel';
import type { SerpCardDistance } from '../model/types';

export const SERP_CARD_BEACH_LINE_ICON: `${IconName}` = IconName.Sea;

export const SERP_CARD_BEACH_TYPE_ICON: `${IconName}` = IconName.FlipFlops;

export const SERP_CARD_FEATURE_ICONS: Record<HotelFeature, `${IconName}`> = {
  [HotelFeature.AirConditioner]: IconName.Conditioning,
  [HotelFeature.Wifi]: IconName.Wifi,
  [HotelFeature.NearTheBeach]: IconName.Beach,
  [HotelFeature.NearTheLift]: IconName.Ski,
  [HotelFeature.NearTheCenter]: IconName.Pin,
  [HotelFeature.WithKids]: IconName.Child,
  [HotelFeature.ForCouples]: IconName.Heart,
  [HotelFeature.AdultsOnly]: IconName.AdultsOnly,
  [HotelFeature.Wellness]: IconName.Spa,
};

export const SERP_CARD_DISTANCE_ICONS: Record<SerpCardDistance, `${IconName}`> = {
  airport: IconName.Plane,
  beach: IconName.MapRoute,
  center: IconName.Hotel,
};
